import React from 'react';
import Logo from "../../assets/images/cec-logo.svg";

const Header = () => {

    return (
        <React.Fragment>
            <header className="page__header">
                <div className="page__container">
                    <div className="text-center mb-4 my-sm-auto">
                        {/* Relative link, not an absolute CEC-website URL: redux-first-router intercepts this
                            and routes HOME ('/'), which redirects to the signed-in user's own landing page. */}
                        <a href="/" >
                            <img className="header__logo" src={Logo}  alt="The Careers & Enterprise Company" />
                        </a>
                    </div>
                    <div className="text-center my-sm-auto ms-sm-auto">
                        <ul className="list-unstyled list-inline m-0 p-0">
                            <li className="list-inline-item font-14 me-0 me-sm-5"><strong>Careers Leader Training Portal</strong></li>
                            <li className="d-none d-sm-inline-block list-inline-item">
                                <a href={`https://tools.support.careersandenterprise.co.uk/`}  className="cec-btn cec-btn-secondary-teal link-as-button font-14" data-cy="tools-button">Tools</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </header>
        </React.Fragment>
    );
};

export default Header;
